import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { EncrDecrService } from '../services/encr-decr.service';

@Injectable({ providedIn: 'root' })
export class CruiseService {
    loginType = "B2C"; private baseURL: any = ''; private encryptPassword: any = environment.encryptPassword;
    constructor(@Inject(PLATFORM_ID) private platformId: Object, private http: HttpClient, platformLocation: PlatformLocation, private EncrDecr: EncrDecrService) {
        if (isPlatformBrowser(this.platformId)) this.baseURL = (platformLocation as any).location.origin;
    }

    getProfile(str, dateupto) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = str + '()' + dateupto + '^&*Get^&*' + this.baseURL + '^&*profile';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    createLead(lead, userID, logindata) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data1 = window.btoa(unescape(encodeURIComponent(lead.name + "()" + lead.email + "()" + lead.phone + "()" + lead.city + "()" + lead.cruiseName + "()" + userID + "()" +
            "UserMessage" + "()" + this.getloginType() + "()" + logindata)));
        var data = data1 + '^&*Add^&*' + this.baseURL + '^&*createlead';

        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getcruisemanageUp(category, LoginId,) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = category + "()" + this.getloginType() + "^&*" + LoginId + "^&*Get^&*" + this.baseURL + "^&*dashboard";

        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getcruisemanageUpDATE(category, LoginId,) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = category + "()" + this.getloginType() + "^&*" + LoginId + "^&*Edit^&*" + this.baseURL + "^&*dashboard";

        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    subscribe(name, email) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = name + "()" + email + "()" + this.getloginType() + "^&*Add^&*" + this.baseURL + "^&*subscribe";
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    applink(mobile) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = mobile + "()" + this.getloginType() + "^&*Add^&*" + this.baseURL + "^&*applink";
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getPricingDetails(CruiseLine, ShipName, FriendlyCruiseName, nights, room, selectedFARE, tcsper, agentcode, agentid) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        let night = nights.replace('-Nights', '').trim();

        var data = CruiseLine + '()' + ShipName + '()' + FriendlyCruiseName
            + '()1:' + night + '()' + room.date + '()' + room.type + "," + room.type
            + ',' + room.adults + 'A,' + room.childs + 'C,' + room.infants + 'I|()' + selectedFARE + '()' + this.getloginType() + '()' + agentcode + '()' + agentid + '()' + tcsper + '^&*get^&*' + this.baseURL + '^&*cruisePriceData';

        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getPricingDetailsnew(CruiseLine, ShipName, FriendlyCruiseName, nights, room, farebase, loginType, agentcode, agentid) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        let night = nights.replace('-Nights', '').trim();
        var data = CruiseLine + '()' + ShipName + '()' + FriendlyCruiseName
            + '()1:' + night + '()' + room.date + '()' + room.room + '()' + farebase + '()' + loginType + '()' + agentcode + '()' + agentid + '^&*get^&*' + this.baseURL + '^&*cruisePriceData';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    generateOrderId(amount, currency) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = amount + '()' + currency + '()()()()()()()()' + this.getloginType() + '^&*order^&*' + this.baseURL + '^&*razorpay';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    agentWallet(amount, currency) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = amount + '()' + currency + '()()()()()()()()' + this.getloginType() + '^&*order^&*' + this.baseURL + '^&*agentwallet';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    verifyPaymentDetails(resp) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = resp.razorpay_payment_id + '()' + resp.razorpay_order_id + '()' + resp.razorpay_signature + "()" + this.getloginType() + '()()()()()()^&*capture^&*' + this.baseURL + '^&*razorpay';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    errorPaymentDetails(resp) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = resp.metadata.payment_id + '()' + resp.metadata.order_id + '()' + resp.description + "()" + this.getloginType() + '()()()()()()^&*failed^&*' + this.baseURL + '^&*razorpay';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getPromoCodes() {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = this.getloginType() + '()()^&*Get^&*' + this.baseURL + '^&*promocode';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    applyPromoCode(code, amount) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = code + '()' + amount + "()" + this.getloginType() + '()^&*apply^&*' + this.baseURL + '^&*promocode';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    makeFinalSubmission(data) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getCruiseBookingReport(fromdate, todate, code, type, agentid?) {
        var data = fromdate + "," + todate + "," + code + "," + type + ",,,,~~" + agentid + "^&*" + this.baseURL + "^&*bookingReport"; let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getCruiseDetails(transactionId, logintype?, agentcode?, agentid?) {
        var data = transactionId + "~" + agentid + "~" + agentcode + "~" + logintype + "~" + "^&*" + this.baseURL + "^&*cruisedetails";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    Cancelticket(txnid, code, Type, remarks) {
        var data = txnid + "," + code + "," + Type + "," + remarks + "," + "^&*" + this.baseURL + "^&*Cancel";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    updatepnr(txnid, code, Type, PNR, Deck, Cabin, actionType) {
        var data = txnid + "()" + code + "()" + Type + "()" + PNR + "()" + Deck + "()" + Cabin + "()" + "^&*" + actionType + "^&*" + this.baseURL + "^&*updatereservation";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    cruisedetails(txnid, agent) {
        var data = txnid + "~~~~^&*" + 'Get' + "," + "^&*" + this.baseURL + "^&*cruisedetails";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    cruiselogs(txnid, agent, cruiseline) {
        var data = txnid + '()' + JSON.stringify(agent) + '()' + cruiseline + '()()' + "^&*" + 'Get' + "," + "^&*" + this.baseURL + "^&*bookinglogs";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getcabinLayout(details, cabin, pax, room, selectedAPI, actionType, method) {
        // var data = details + "," + cabin + "," + pax + "," + room  + "^&*" +actionType+ "^&*"+ this.baseURL + "^&*"+method;
        var data = details + "()" + cabin + "()" + pax + "()" + room + "()" + selectedAPI + "^&*" + actionType + "^&*" + this.baseURL + "^&*" + method;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getdecks(details, cabin, paxcount, selectedAPI, actionType, method) {
        // var data = details + "," + cabin + "^&*" +actionType+ "^&*"+ this.baseURL + "^&*"+method;
        var data = details + "()" + cabin + "()" + paxcount + "()" + selectedAPI + "()" + selectedAPI + "^&*" + actionType + "^&*" + this.baseURL + "^&*" + method;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getDecrypt(Data) {
        try {
            var encryptData = Data;
            var resp = window.atob(encryptData);
            encryptData = JSON.parse(resp);
        }
        catch (errormsg) {
            console.log(errormsg);
        }
        return encryptData;
    }
    voucheremail(txnid, mail) {
        var data = txnid + "()" + mail + "()()()()()" + '^&*voucher' + "^&*" + this.baseURL + "^&*voucheremail";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getvessels(CruiseCode, paxcount, saildate, room, vesselslist?) {
        var data = CruiseCode + "()" + paxcount + "()" + saildate + "()" + room + "^&*" + "get" + "^&*" + this.baseURL + "^&*" + vesselslist;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getledgerStatement(fromdate, todate, code, type, agentid?) {
        var data = fromdate + "," + todate + ",,,,,~" + code + "~" + type + "~" + agentid;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getstatusReport(fromdate, todate, code, type, agentid?) {
        var data = fromdate + "," + todate + ",,,,,~" + code + "~" + type + "~" + agentid;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getloginType() {
        if (isPlatformBrowser(this.platformId)) {
            if (!sessionStorage.getItem("loginType")) {
                this.loginType = "B2C";
            } else { this.loginType = sessionStorage.getItem("loginType"); }
        }
        return this.loginType;
    }

    loginAgent(username, password, type) {
        let rNo = Math.round((Math.random() * 100000) * 100);
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = username + '()' + password + '()' + type + '()' + rNo + '^&*login^&*' + this.baseURL + '^&*adminlogin';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    registerAgent(agent, agenttype?, logo?, filename?) {
        var data = agent.email + "()" + agent.agencyName + "()" + agent.contactPerson
            + "()" + agent.lastName + "()" + agent.designation + "()" + agent.phone + "()" + agent.mobile + "()" + agent.address + "()"
            + agent.city + "()" + agent.state + "()" + agent.country + "()" + agent.pincode + "()" + agent.passwordss + "()" + agent.gstNo +
            "()" + agent.panNo + "()" + agenttype + "()" + logo + "()" + filename + "()" + agent.agencyType + '^&*register^&*' + this.baseURL + '^&*adminlogin';

        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    forgetPassword(username, type) {
        let rNo = Math.round((Math.random() * 100000) * 100);

        var data = username + "()" + type + "()" + rNo + '^&*forgetpassword^&*' + this.baseURL + '^&*adminlogin';
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getHomePageData(pgName?) {
        var encryptData = pgName;
        var data = '^&*^&*' + this.baseURL + '^&*merchantSetup';
        let headers = new HttpHeaders(
            {
                'content-type': 'application/json'
            }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    removemerchantCache() {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );

        var data = "^&*^&*" + this.baseURL + "^&*" + "removemerchantcache";
        return this.http.post(environment.baseUrl, { "searchData": data },
            { headers: headers });
    }

    getCruiseOrgList(supplier) {
        var data = supplier + "^&*" + this.baseURL + "^&*" + "supplierbookinglist";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getCruiseBalance(supplier) {
        var data = supplier + "^&*" + this.baseURL + "^&*" + "supplierwallet";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getdecryptData(encryptStr) {
        var encryptData = this.EncrDecr.get(environment.encryptPassword, encryptStr.split(' ').join('+'));
        return encryptData;
    }

    getdecryptDataSSO(encryptStr) {
        var encryptData = this.EncrDecr.getHex(environment.encryptPassword, encryptStr.split(' ').join('+'));
        return encryptData;
    }

    saveSetupData(orgData) {
        localStorage.setItem("merchantData", orgData);
    }

    getSetupData() {
        var encryptData = "";
        var systemsetup = localStorage.getItem("merchantData");
        try {
            encryptData = (this.getdecryptData(systemsetup));
            systemsetup = JSON.parse(JSON.parse(encryptData).merchantsetup);
        }
        catch (errormsg) {
            try { systemsetup = JSON.parse(localStorage.getItem("merchantData")); } catch (error) { systemsetup = ""; }
        }
        return systemsetup;
    }

    getAvailableOffers(type, product?) {

        var data = type + "()" + product + "()" + this.baseURL + "^&*" + "^&*" + this.baseURL + "^&*" + "availableoffers";
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);

        var url = environment.baseUrl;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

    getpageOffers(pagename) {
        var pageoffer = JSON.parse(localStorage.getItem(this.baseURL + "offers"));
        var pagetagarray = [];
        for (let mtag of pageoffer) {
            if (pagename.indexOf(mtag.Product) > -1) { pagetagarray.push(mtag); }
        }
        return pagetagarray;
    }
    
    getPGData(logintype?) {
        var alldata = logintype + "~" + this.baseURL + "^&*book^&*" + this.baseURL + "^&*pgdata"
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(environment.baseUrl, { "searchData": alldata }, { headers: headers });
    }
        
    applyPromoCodeRecharge(code, amount, product) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = code + '()' + amount + "()" + product + "()" + this.getloginType() + '()^&*apply^&*' + this.baseURL + '^&*promocodeflt';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getPGCharge(pgName, totalprice, pax, domInt, trip, product, logintype, utmSource?, transaction?) {
        var data = pgName + "," + totalprice + "," + pax + "," + domInt + "," + trip + "," + product + "," + logintype + "," + utmSource + "~" + transaction + "~" + this.baseURL;
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);

        var url = environment.rechargeUrl + "/pgCharge";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }
    
    getROE(sid, usdRate, eurRate, param1?, param2?, methodname?) {
        var data = sid + "()" + usdRate + "()" + eurRate + "()" + param1 + "()^&*" + param2 + "^&*" + this.baseURL + "^&*" + methodname;
        var encryptData = this.EncrDecr.set(environment.encryptPassword, data);
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
}